import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChatPage from "./ChatPage";
import Login from "./Login";
// import QuestionnairePage from "./QuestionnairePage";
import AuthCallback from "./AuthCallback";
import TermsOfService from "./TermsOfService";
import TermsConsent from "./TermsConsent";
import RequireTerms from "./RequireTerms";

const App = () => {
    const [user, setUser] = useState(localStorage.getItem("user") || null);

    // Ensure `user` updates when localStorage changes
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser !== user) {
            setUser(storedUser);
        }
    }, [user]);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login setUser={setUser} />} />
                <Route path="/auth/callback" element={<AuthCallback setUser={setUser} />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/consent" element={<TermsConsent />} />
                {/* Protected pages: must be logged in AND have accepted terms */}
                <Route element={<RequireTerms />}>
                    <Route path="/chat" element={<ChatPage user={user} />} />
                    {/* <Route path="/questionnaire" element={<QuestionnairePage />} /> */}
                </Route>
            </Routes>
        </Router>
    );
};

export default App;
